const taekwondoDrills = [
  // BEGINNER TAEKWONDO BASICS (30 minutes) Done
  {
    id: 2120,
    name: 'Beginner Taekwondo Basics',
    categories: ['Basics', 'beginner'],
    sports: ['taekwondo'],
    difficulty: 'beginner',
    skill: 'Basics',
    points: 30,
    instructions:
      "Get ready for a secret hero training mission! This super fun adventure will teach you awesome hero stances, lightning-fast kicks, and powerful blocks. Let's fire up your energy and become a Taekwondo champion!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, Taekwondo hero! Let's jump right into your Fighter Stance! That means feet nice and wide, bend your knees like you're about to spring into action, and bring your hands up by your cheeks to make a superhero shield!",
      },
      {
        time: 12,
        text: 'Perfect! Now start bouncing on your feet! Heel, toe, heel, toe! Be light and ready for anything! Keep that shield up!',
      },
      {
        time: 25,
        text: "Let's warm up our whole body with ten Star Jumps! Go! One, two, three, four, five, six, seven, eight, nine, ten! Awesome!",
      },
      {
        time: 40,
        text: 'Back to bouncing! Great energy! Now shuffle two steps to the right... and two steps to the left! Keep your eyes forward, you look like a champion!',
      },
      {
        time: 52,
        text: 'Time for High Knee Sprints! Stay in one spot and run, but try to get your knees up to your belly button! Go, go, go! Faster!',
      },
      {
        time: 70,
        text: 'Great job! Back to shuffling left and right! Keep those hands up!',
      },
      {
        time: 80,
        text: "Now for Butt Kicks! Try to kick your bottom as you jog in place! It's silly and fun! Let's go!",
      },
      {
        time: 95,
        text: 'And... TIGER FREEZE! Hold that fighter stance perfectly still like a powerful tiger! Knees bent? Hands up? You look so strong! Okay, start bouncing again!',
      },
      {
        time: 105,
        text: "Time for our first move: the Right Leg Lightning Kick! To do it, lift your knee up high like you're stepping over a giant puddle, then SNAP your foot straight out and pull it right back, super fast!",
      },
      {
        time: 120,
        text: "Let's try five slow ones to get it right. Right leg, go! One... Two... Three... Four... and Five! Keep those hands up!",
      },
      {
        time: 140,
        text: "You got it! Now let's do five super-fast ones! Like lightning! Ready? Go! SNAP! SNAP! SNAP! SNAP! SNAP!",
      },
      {
        time: 150,
        text: 'Fantastic! Time for the Left Leg Lightning Kick! Same thing! Lift that left knee up high, SNAP the foot out, and bring it right back!',
      },
      {
        time: 162,
        text: "Let's do five slow and steady kicks with the left leg. Remember to look at one spot to keep your balance! Go! One... Two... Three... Four... Five!",
      },
      {
        time: 182,
        text: 'Perfect! Now five left leg lightning strikes! Be as fast as you can! Go! SNAP! SNAP! SNAP! SNAP! SNAP! Wow!',
      },
      {
        time: 192,
        text: "BALANCE CHALLENGE! Do a right leg Lightning Kick and... FREEZE! Hold your leg out there! Don't wobble! Five, four, three, two, one! Great! Now the left leg... kick and FREEZE! Five, four, three, two, one! You're a statue!",
      },
      {
        time: 212,
        text: 'SPEED DRILL TIME! How many Lightning Kicks can you do in 20 seconds? You have to switch legs each time! Right, then left, then right! Ready... Set... GO!',
      },
      {
        time: 232,
        text: "Time's up! Woo! Amazing speed! Shake out your legs and get ready for our next move!",
      },
      {
        time: 242,
        text: "Next up is the Side Blaster kick! For this, turn your bottom foot to face the side, pull your kicking knee way up to your chest, then BLAST your heel sideways like you're pushing open a heavy door! STOMP!",
      },
      {
        time: 258,
        text: "Let's practice! Five slow Side Blasters with your right leg. Remember: turn your bottom foot, knee up, then BLAST! That's one! Four more, nice and strong!",
      },
      {
        time: 283,
        text: "You've got the power! Now let's do five fast and powerful Side Blasters! Go! BLAST! BLAST! BLAST! BLAST! BLAST!",
      },
      {
        time: 298,
        text: 'Awesome! Time for the left leg! Get ready! Turn your right foot to the side, pull that left knee up, and get ready to BLAST!',
      },
      {
        time: 310,
        text: "Let's do five slow ones to get it perfect. Turn, knee up, BLAST! Make sure you are pushing with your heel! Keep going!",
      },
      {
        time: 335,
        text: 'Fantastic form! Now five fast ones with all your power! Ready? Go! BLAST! BLAST! BLAST! BLAST! BLAST!',
      },
      {
        time: 350,
        text: "SIDE BLASTER SPEED DRILL! Switch legs each time! Right BLAST! Left BLAST! Let's see how many you can do in 20 seconds! Get ready... GO!",
      },
      {
        time: 370,
        text: "And STOP! Incredible work! Grab a super quick 10-second water break! We're going again!",
      },
      {
        time: 385,
        text: 'ROUND TWO! Another 20 seconds of Side Blasters! Try to beat your last score! Ready? GO!',
      },
      {
        time: 405,
        text: "Time! Amazing effort! Back in your Fighter Stance! Bouncing, bouncing! Let's practice blocks!",
      },
      {
        time: 420,
        text: "First is the High Block. Swing your arm up to protect your head, like you're blocking a giant water balloon! Next is the Low Block! Swing your arm down and across your body, like you're sweeping away pesky lava from your feet! WHOOSH!",
      },
      {
        time: 438,
        text: "BLOCK DRILL! I'm going to call it out, you do the block! Ready? HIGH BLOCK! LOW BLOCK! LOW BLOCK! HIGH BLOCK! RIGHT ARM HIGH! LEFT ARM LOW! FASTER! HIGH! LOW! HIGH! LOW! Great job!",
      },
      {
        time: 463,
        text: 'Time for Rocket Punches! Your front hand is the Jab, a quick little punch straight out and back! Pew! Your back hand is the Cross, where you twist your body for extra power! POW!',
      },
      {
        time: 478,
        text: "Let's practice the one-two combo! JAB-CROSS! JAB-CROSS! Punch straight out and pull your hands right back to your superhero shield!",
      },
      {
        time: 493,
        text: 'PUNCHING SPEED DRILL! How many Jab-Cross combos can you do in 15 seconds? Be a blur of fists! Ready... GO!',
      },
      {
        time: 508,
        text: "Time! Your hands are on fire! Let's make a new combo! Right side! Do a High Block, then a Cross punch! Ready? BLOCK-POW! Let's do that five times!",
      },
      {
        time: 528,
        text: 'Now the left side! Left High Block, then a left Cross punch! Five times! Go! BLOCK-POW!',
      },
      {
        time: 548,
        text: "Now for the super fun Slingshot Kick! To do this, turn on the ball of your bottom foot, point your knee at your target, and WHIP the top of your foot across like you're kicking a soccer ball sideways! SWOOSH!",
      },
      {
        time: 563,
        text: "Let's try five slow ones with the right leg to feel that whip! Turn, point your knee, and WHIP! Again! Keep your hands up!",
      },
      {
        time: 588,
        text: "Perfect! Now five fast ones! Make a 'swoosh' sound every time you kick! Go! SWOOSH! SWOOSH! SWOOSH! SWOOSH! SWOOSH!",
      },
      {
        time: 603,
        text: 'Amazing! Now for the left leg! Turn on your right foot, point your left knee, and get ready for the Slingshot!',
      },
      {
        time: 615,
        text: "Five slow and controlled kicks with the left leg. Focus on that turn and whip! Let's see it!",
      },
      {
        time: 640,
        text: "You're a natural! Now give me five super fast ones! Let me hear that SWOOSH! GO! SWOOSH! SWOOSH! SWOOSH! SWOOSH! SWOOSH!",
      },
      {
        time: 655,
        text: "COMBO BUILDER TIME! Let's make a hero combo! We start small and add on! First move, right side: a Jab-Cross! Ready? Go! JAB-CROSS!",
      },
      {
        time: 668,
        text: "Great! Now add a kick! Right Jab-Cross, then a right Lightning Kick! Let's do it three times! JAB-CROSS... KICK! Go!",
      },
      {
        time: 688,
        text: "Awesome! Now let's add a block! Right Jab-Cross, right Lightning Kick, then a right High Block! Let's do that big combo two times! PUNCH-PUNCH, KICK, BLOCK! Go!",
      },
      {
        time: 708,
        text: 'Now the left side! Just the Jab-Cross! Go!',
      },
      {
        time: 718,
        text: 'Now add the kick! Left Jab-Cross, left Lightning Kick! Three times!',
      },
      {
        time: 738,
        text: "Time for the big combo! Left Jab-Cross, left Lightning Kick, left High Block! Let's do it two times! Go!",
      },
      {
        time: 758,
        text: 'You are a combo master! It is time for the FINAL BOSS CHALLENGE!',
      },
      {
        time: 768,
        text: "The combo is: a Low Block, then a Side Blaster, then a Slingshot Kick! All on the same side! Let's start with the right side. BLOCK... BLAST... WHIP!",
      },
      {
        time: 783,
        text: "Let's do it for real! FIVE times on the right side! Give me your loudest KIAI, your power sound, on the kicks! Ready? GO!",
      },
      {
        time: 813,
        text: 'Incredible! Shake it out! Now the left side! This is the final challenge! Left Low Block, left Side Blaster, left Slingshot Kick!',
      },
      {
        time: 828,
        text: 'Give it all your energy! FIVE times on the left side! The best ones of the day! GO!',
      },
      {
        time: 858,
        text: 'YOU DID IT! You defeated the Final Boss Challenge! AMAZING! Stop and catch your breath! You are a true champion!',
      },
      {
        time: 873,
        text: 'Whew! Time to cool down our super muscles. Stand with your feet wide and take a giant breath in, reach for the sky!',
      },
      {
        time: 883,
        text: "And breathe out, letting your arms float down. Let's do that one more time. Biggest breath of the day in... and let it all out.",
      },
      {
        time: 893,
        text: "Now, let's thank our amazing legs. Gently pull your right foot up toward your back. Hold onto a wall if you need to! Feel that stretch.",
      },
      {
        time: 908,
        text: 'Great! Now switch legs. Gently pull your left foot up. Your legs did so many awesome kicks today!',
      },
      {
        time: 923,
        text: 'You learned so many new moves! Stances, blocks, punches, and THREE kinds of powerful kicks! You should be very proud!',
      },
      {
        time: 933,
        text: "You are an official Taekwondo hero. Let's finish with our sign of respect. Feet together, hands by your side... and a big, strong bow.",
      },
      {
        time: 943,
        text: 'Incredible work today! Give yourself a huge pat on the back! See you for the next training mission!',
      },
    ],
    timeTotal: 950,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // INTERMEDIATE TAEKWONDO KICKS (45 minutes) Done
  {
    id: 2121,
    name: 'Intermediate Taekwondo Kicks',
    categories: ['Kicks', 'intermediate'],
    sports: ['taekwondo'],
    difficulty: 'intermediate',
    skill: 'Kicks',
    points: 45,
    instructions:
      "Welcome to Level Two, Taekwondo Hero! Are you ready to upgrade your kicks? This mission is all about super speed, mega power, and awesome new moves! We will learn kicks that slide, switch, and even spin! Let's become a kicking legend!",
    timedInstructions: [
      {
        time: 0,
        text: "Alright team, let's begin! Jump into your strong Fighter Stance! Feet wide, knees bent, and hands up by your face like a super shield! Look ready for action!",
      },
      {
        time: 12,
        text: "Start your bounce! Heel, toe, heel, toe! Be light on your feet. Now let's wake up your legs! Hold onto a wall if you need to, and swing your right leg forward and back like a giant pendulum! Ten times!",
      },
      {
        time: 28,
        text: "Great! Now switch to the left leg. Swing it forward and back ten times! Get it nice and loose for all the awesome kicks we're about to do!",
      },
      {
        time: 44,
        text: "Back to your stance! Let's move with light tiger feet! Shuffle right, shuffle left! Quick feet! Keep that guard up!",
      },
      {
        time: 59,
        text: "And... TIGER FREEZE! Hold that stance! Are your hands up? Are your knees bent? Perfect! Let's start kicking!",
      },
      {
        time: 70,
        text: "Let's level up the Slingshot Kick! Remember, turn on your bottom foot and WHIP the top of your other foot across! Let's do ten powerful ones on the right!",
      },
      {
        time: 90,
        text: 'Now ten on the left! Turn and WHIP! Make a swoosh sound!',
      },
      {
        time: 110,
        text: "Time for a new trick: the Slide Slingshot! To do it, slide your back foot up to your front foot and KICK at the exact same time! It's a super-fast surprise attack! Zoooom-KICK!",
      },
      {
        time: 127,
        text: "Let's do ten with the right leg! Remember, slide and kick together! Go!",
      },
      {
        time: 147,
        text: "Now ten with the left leg! Slide and KICK! You're so fast!",
      },
      {
        time: 167,
        text: 'Now for an even faster trick: the Switcheroo Kick! You switch your feet super fast, like a magic trick, and kick with the new front leg! So to do a right kick, your right foot starts in back... then SWITCH and KICK instantly!',
      },
      {
        time: 185,
        text: "Let's do ten Right Switcheroo Slingshot kicks! Switch and KICK! Go!",
      },
      {
        time: 205,
        text: 'Now ten Left Switcheroo Slingshot kicks! Your left foot starts in back... Switch and KICK! Amazing!',
      },
      {
        time: 225,
        text: 'SPEED DRILL! 30 seconds of Switcheroo Kicks! Switch legs each time! How fast can you be? GO!',
      },
      {
        time: 255,
        text: 'Time! Incredible speed! Next up, the Side Blaster!',
      },
      {
        time: 265,
        text: 'Remember the Side Blaster? Turn your bottom foot, pull your knee to your chest, and BLAST your heel sideways like pushing a heavy door!',
      },
      {
        time: 277,
        text: "Let's play the Ladder Game! With your right leg, do one kick low, by the ankle. Then one to the knee! Then one up to the tummy! Low... Medium... HIGH! We're going to do that whole set four times! Go!",
      },
      {
        time: 317,
        text: 'Fantastic! Now the left leg gets to play the Ladder Game! Four times through! One kick low, one medium, one high! Go for it!',
      },
      {
        time: 357,
        text: "Time for a brand new move: the Donkey Kick! It's a super powerful kick straight behind you!",
      },
      {
        time: 368,
        text: "Here's how you do it: First, peek over your right shoulder to see your target. Then, pull your knee to your chest and BLAST your heel straight back, just like a donkey!",
      },
      {
        time: 383,
        text: "Let's do eight slow and strong ones with the right leg. The most important part is to LOOK first, then kick! Go!",
      },
      {
        time: 410,
        text: 'POWER ROUND! Now four fast and powerful ones on the right! Go! BLAST, BLAST, BLAST, BLAST!',
      },
      {
        time: 425,
        text: 'Great! Now the left leg. Eight slow and strong ones! Peek over your left shoulder, pull that knee up, and BLAST it back!',
      },
      {
        time: 452,
        text: 'POWER ROUND! Four fast ones on the left! Make a loud KIAI! Go!',
      },
      {
        time: 467,
        text: "Time for a sneaky move: the Question Mark Kick! It's called that because it draws a question mark in the air!",
      },
      {
        time: 479,
        text: "Here's how: Lift your right leg and kick it straight out, PAST your target. Then, without putting it down, bend your knee and WHIP your heel backwards to hit the target! Out, and then HOOK!",
      },
      {
        time: 496,
        text: "Let's practice ten with the right leg! Remember, kick past it, then hook it back! Go! Out-HOOK!",
      },
      {
        time: 521,
        text: 'Now ten with the left leg! This one takes practice, so focus! Kick it out past the target, then HOOK it back!',
      },
      {
        time: 546,
        text: "DOUBLE KICK COMBO! Do a right Slingshot Kick, but without putting your foot down, turn it into a Question Mark Kick! It's a WHIP-HOOK! Let's do it five times! So tricky!",
      },
      {
        time: 571,
        text: "Now the left leg! Five left WHIP-HOOKS! This is a super advanced combo, and you're doing it!",
      },
      {
        time: 596,
        text: "Okay hero... it's time. Get ready for the coolest kick of all... the TORNADO KICK!",
      },
      {
        time: 607,
        text: 'The Tornado Kick is a spinning Donkey Kick! We have to learn it in three easy steps. Step one: LOOK! Turn and look all the way over your right shoulder!',
      },
      {
        time: 622,
        text: 'Step two: TURN! After you look, let your whole body spin around.',
      },
      {
        time: 632,
        text: "Step three: KICK! As you finish spinning, BLAST that Donkey Kick straight out! Let's put it together slowly. Look... turn... KICK!",
      },
      {
        time: 647,
        text: "Let's do five slow and controlled right Tornado Kicks. Focus on seeing your target before you kick! This is awesome!",
      },
      {
        time: 672,
        text: 'POWER ROUND! Now five fast and powerful Tornado Kicks on the right! Go!',
      },
      {
        time: 692,
        text: 'Now the left side! Five slow and controlled ones! Look over your left shoulder... turn your body... and BLAST that kick straight back!',
      },
      {
        time: 717,
        text: 'POWER ROUND! Five fast ones on the left! Give me your loudest KIAI! Go!',
      },
      {
        time: 737,
        text: 'You are a spinning tornado of power! It is time for the ULTIMATE COMBO CHALLENGE!',
      },
      {
        time: 747,
        text: "First is the Tiger's Fury Combo! It goes: Right Slide Slingshot kick, then a Left Side Blaster, then a Right Donkey Kick! Let's try it slowly. Slide-WHIP... Side-BLAST... Donkey-KICK!",
      },
      {
        time: 767,
        text: "Okay, let's do the Tiger's Fury Combo five times! Give me your loudest KIAI! Go!",
      },
      {
        time: 802,
        text: "Amazing! Now for the Dragon's Tail Combo! It's a Left Switcheroo Slingshot, then a Right Question Mark Kick, then a Left Slingshot Kick! So fast and tricky!",
      },
      {
        time: 822,
        text: "Let's do the Dragon's Tail Combo five times! This is a big challenge! Everything you've got! Go!",
      },
      {
        time: 857,
        text: "Final Combo! The Grandmaster's Seal! It's a Right Tornado Kick, a Left Question Mark Kick, and a Right Side Blaster! The ultimate test!",
      },
      {
        time: 877,
        text: "Let's do the Grandmaster's Seal three times! Make them the best three combos of the day! GO!",
      },
      {
        time: 902,
        text: 'YOU DID IT! You are officially a kicking master! Stand with your feet wide and catch your breath. You earned it!',
      },
      {
        time: 914,
        text: 'Take a giant breath in, reach your hands up to the ceiling... and let it all out with a big sigh. One more time. Big breath in... and out.',
      },
      {
        time: 929,
        text: "Let's stretch our amazing legs. Put your right heel on the floor in front, with your toes pointing up. Gently lean forward and hold for ten seconds.",
      },
      {
        time: 944,
        text: 'Great! Now switch sides. Left heel out, toes up, and lean forward. Hold for ten seconds.',
      },
      {
        time: 959,
        text: 'You should be so proud! You mastered sliding kicks, donkey kicks, and even the TORNADO kick! Now, stand tall and proud.',
      },
      {
        time: 974,
        text: "Let's finish with our sign of respect. Feet together, hands at your sides... and a powerful bow. Fantastic job today, hero! See you next time!",
      },
    ],
    timeTotal: 985,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // ADVANCED TAEKWONDO TECHNIQUES (45 minutes) Done
  {
    id: 2122,
    name: 'Advanced Taekwondo Techniques',
    categories: ['Techniques', 'advanced'],
    sports: ['taekwondo'],
    difficulty: 'advanced',
    skill: 'Techniques',
    points: 45,
    instructions:
      "Welcome to the Grandmaster's Challenge! This is your final test, hero! We'll unleash powerful spinning kicks, awesome flying attacks, and lightning-fast combos. It's time to show everyone your black belt power. Let's begin!",
    timedInstructions: [
      {
        time: 0,
        text: "Advanced squad, let's begin! Assume your Fighter Stance! Feet wide, knees bent, tummy tight, and your guard glued to your cheeks. Show me your focus!",
      },
      {
        time: 11,
        text: "Start a light, quick bounce, heel-to-toe. Let's fire up your hip engine! A tiny, sharp twist right, then left. All your power starts here. Keep that guard up!",
      },
      {
        time: 24,
        text: "Let's warm up our hips for spinning! Hold a wall and swing your right leg in a big circle in front of your body, five times one way, then five times the other! Get those hips loose!",
      },
      {
        time: 42,
        text: 'Switch legs! Big circles with the left leg, five one way, five the other! This is the secret to fast spins!',
      },
      {
        time: 60,
        text: "Great! Now some torso twists! Feet planted, twist your body left and right! Let's do twenty!",
      },
      {
        time: 80,
        text: "Back to your stance! Let's master the Cyclone Kick! Think of it like a spinning Question Mark Kick. It's tricky, so we'll learn it in four easy steps!",
      },
      {
        time: 95,
        text: "Step one: Step your back foot across your body. Two: Lift your front knee high like a shield. Three: Peek over your front shoulder to find your target. Four: Spin and WHIP that kick around! Let's drill that slowly. Step, knee, look, KICK!",
      },
      {
        time: 115,
        text: "Let's try five full Cyclone Kicks with your right leg! Remember the steps! Make it smooth and fast! Go!",
      },
      {
        time: 135,
        text: 'Now the left leg! Step across with your right foot, lift your left knee, peek over your left shoulder, and WHIP it! Five smooth Cyclone Kicks!',
      },
      {
        time: 155,
        text: "SPEED ROUND! Let's do ten more on the right leg, but smaller and faster! Go! One, two, three, four, five, six, seven, eight, nine, ten!",
      },
      {
        time: 175,
        text: 'Now ten fast ones on the left! Quick feet, sharp kicks! Go!',
      },
      {
        time: 195,
        text: 'Incredible! Next up, the Dragon Wheel! This is a full 360-degree Slingshot kick! The ultimate power move!',
      },
      {
        time: 210,
        text: "Before we kick, let's practice the spin. Just look way over your back shoulder and do a full 360-degree jump, landing in your fighter stance. Let's do five practice spins!",
      },
      {
        time: 230,
        text: "Now let's add the kick! As you finish your spin and see your target again, WHIP out a Slingshot Kick! It's a spin-and-WHIP!",
      },
      {
        time: 245,
        text: "Let's do five slow and controlled Dragon Wheels with your right leg. Focus on a tight spin and a strong kick at the end!",
      },
      {
        time: 275,
        text: "Now the left leg! Look over your left shoulder, spin all the way around, and WHIP that left kick! Five times! You're a tornado!",
      },
      {
        time: 305,
        text: 'Time for the Comet Kick! This is your Tornado Kick, but with maximum power! Remember, look over your shoulder and BLAST your heel straight back!',
      },
      {
        time: 320,
        text: "Let's do ten powerful Comet Kicks with the right leg! Drive that heel back like a rocket! Go!",
      },
      {
        time: 350,
        text: 'Now ten with the left leg! Look, then BLAST! Make a power sound! KIAI!',
      },
      {
        time: 380,
        text: "COMBO DRILL! Let's do a right Slingshot Kick, and then flow right into a right Comet Kick! It's a WHIP then a SPIN-BLAST! Let's do that five times!",
      },
      {
        time: 405,
        text: 'Now the left side! Left Slingshot into a left Comet Kick! Five times! Great transitions!',
      },
      {
        time: 430,
        text: 'Time to take flight! First up is the Sky Kick! This is a flying Side Blaster! Step forward, jump, pull your front knee up high, and in the air, BLAST your other foot out sideways!',
      },
      {
        time: 450,
        text: "Let's do ten right leg Sky Kicks! Focus on getting some air and landing softly like a cat! Go!",
      },
      {
        time: 480,
        text: "Now ten left leg Sky Kicks! Step with your right, jump, and blast that left heel out! You're flying!",
      },
      {
        time: 510,
        text: "Next is the Flying Slingshot Kick! Jump straight up, pull BOTH knees to your chest, and while you're in the air, WHIP out a Slingshot Kick!",
      },
      {
        time: 527,
        text: "Let's do ten with the right leg! Jump, tuck, and KICK! The higher you pull your knees, the more time you have!",
      },
      {
        time: 557,
        text: "Now ten with the left leg! Jump, tuck, KICK! Amazing! Keep bouncing, you're doing great!",
      },
      {
        time: 587,
        text: 'Last new move: the Thunder Axe kick! Lift your leg up as high and straight as you can, then CHOP your heel straight down like a giant hammer!',
      },
      {
        time: 605,
        text: "Let's start with a stretch! Five slow-motion Axe Kicks on the right, stretching as high as you can each time.",
      },
      {
        time: 625,
        text: 'Now five slow stretch-kicks on the left. Reach for the sky!',
      },
      {
        time: 645,
        text: 'Okay, now POWER! Ten fast Thunder Axe kicks on the right! Up and CHOP! Imagine breaking a board!',
      },
      {
        time: 670,
        text: 'Ten fast ones on the left! Stretch it to the sky, then bring the thunder down! Go!',
      },
      {
        time: 695,
        text: "You have learned all the Grandmaster's moves! It is time for the Ultimate Black Belt Combos! Are you ready?!",
      },
      {
        time: 710,
        text: "First is the Dragon's Dance Combo! It's a Right Dragon Wheel, a Left Side Blaster, and a Right Switcheroo Slingshot Kick! Let's try it slowly. Spin-kick... blast... switch-kick!",
      },
      {
        time: 730,
        text: "Okay, let's do the Dragon's Dance FIVE times! Full speed, full power! Go!",
      },
      {
        time: 770,
        text: "Incredible! Shake it out! Next is the Phoenix Flight Combo! It's a Left Sky Kick, a Right Thunder Axe, and a Left Cyclone Kick! Flying, chopping, and spinning!",
      },
      {
        time: 795,
        text: "Let's do the Phoenix Flight FIVE times! Be light on your feet and flow from one kick to the next! Go!",
      },
      {
        time: 835,
        text: "You are a true master! This is it! The Grandmaster's Test! The combo is: a Right Comet Kick, a Left Slide Slingshot, and a Right Flying Slingshot Kick!",
      },
      {
        time: 860,
        text: "This is your final challenge! Give it everything you've got! Five times through, the best you've ever done! Ready? GO!",
      },
      {
        time: 900,
        text: 'MISSION COMPLETE! YOU PASSED! Victory stance! Feet wide, hands high, feel that power! You are amazing! Take a deep breath in... and let it out.',
      },
      {
        time: 915,
        text: "Time for a Grandmaster's cool down. Sit on the floor and put the bottoms of your feet together. Gently pull your heels in and hold for ten seconds.",
      },
      {
        time: 935,
        text: 'Now stretch your legs out wide in front of you. Reach for your right toes and hold for ten seconds... now reach for your left toes and hold for ten seconds. You worked so hard.',
      },
      {
        time: 965,
        text: 'Stand up slowly. You mastered spinning kicks, flying kicks, and epic combos today. You truly have the spirit of a black belt.',
      },
      {
        time: 980,
        text: 'Bring your feet together. It is time for our final sign of respect. Perform a slow, deep, and proud bow. Incredible session, champion!',
      },
    ],
    timeTotal: 990,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // COMPLETE TAEKWONDO MASTERY (60 minutes) DONE
  {
    id: 2123,
    name: 'Complete Taekwondo Mastery',
    categories: ['Complete', 'advanced'],
    sports: ['taekwondo'],
    difficulty: 'advanced',
    skill: 'Complete',
    points: 60,
    instructions:
      "This is it, the final challenge: The Grandmaster's Gauntlet! You will use every punch, kick, block, and spin you've ever learned in one amazing workout! Get ready to combine all your skills and prove you are a true Taekwondo Master!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome to the Gauntlet, Master! Let's begin! Jump into your strongest Fighter Stance! Feet wide, knees bent, and your superhero shield is UP by your face!",
      },
      {
        time: 12,
        text: "Start your champion bounce! Light on your feet! Let's warm up with some Star Jumps! Twenty of them, let's go!",
      },
      {
        time: 40,
        text: 'Great! Back to bouncing! Now, twenty High Knees, get them up to your belly button! Go, go, go!',
      },
      {
        time: 65,
        text: 'Awesome energy! Time to power up your hips! While you bounce, do a tiny, sharp twist right, then left. All your power starts here! Keep that guard up!',
      },
      {
        time: 85,
        text: "And... TIGER FREEZE! Hold that stance! Are your knees bent? Guard up? Perfect power pose! Okay, let's start bouncing!",
      },
      {
        time: 100,
        text: "Let's review your Rocket Punches! We'll play a game called Punching Ladder! First, just the Jab with your front hand! Give me five jabs! Go!",
      },
      {
        time: 120,
        text: 'Great! Now, add the Cross! Give me five Jab-Cross combos! Go! PUNCH-PUNCH!',
      },
      {
        time: 140,
        text: 'Now, add the Hook! Give me five Jab-Cross-Hook combos! Straight, straight, side!',
      },
      {
        time: 165,
        text: 'Finally, the full combo! Add the Uppercut! Five times! Jab-Cross-Hook-Uppercut! Be a blur of fists!',
      },
      {
        time: 195,
        text: 'Now the other side! Five Jabs with your other hand! Go! ... Now five Jab-Cross combos! ... Now five Jab-Cross-Hook combos! ... And finally, five full combos with the Uppercut! Go, go, go!',
      },
      {
        time: 240,
        text: 'Amazing hands! Time for the Basic Kicks Gauntlet! Get ready! First, the Lightning Kick! Knee up, SNAP out and back!',
      },
      {
        time: 255,
        text: "BALANCE CHALLENGE! Do a right Lightning Kick and... FREEZE! Hold it for ten seconds! Don't wobble! Ten, nine... five, four, three, two, one! Now the left leg... kick and FREEZE for ten seconds!",
      },
      {
        time: 285,
        text: "Next, the Side Blaster! Turn your bottom foot and BLAST your heel sideways! Let's play the Ladder Game! Right leg: one kick low, one medium, one high! Let's do that set three times! Go!",
      },
      {
        time: 320,
        text: 'Now the left leg! Three rounds of the Ladder Game! Low, medium, high! Push with that heel!',
      },
      {
        time: 355,
        text: 'Finally, the Slingshot Kick! Turn your bottom foot and WHIP the top of your other foot across! SPEED DRILL! 30 seconds of Slingshot Kicks, switching legs each time! GO!',
      },
      {
        time: 385,
        text: "Time! Take a 15 second rest, catch your breath! We're doing that speed drill one more time! Get ready!",
      },
      {
        time: 400,
        text: 'Round two! 30 more seconds! Go, go, go! Faster than before!',
      },
      {
        time: 430,
        text: 'Time! You passed the first gauntlet! Shake out your legs, get ready for advanced kicks!',
      },
      {
        time: 445,
        text: "First up, the powerful Donkey Kick! Peek over your shoulder, then blast your heel straight back! Let's do ten strong ones with the right leg. Look first, then kick!",
      },
      {
        time: 475,
        text: 'Now ten with the left leg! Peek over your left shoulder and BLAST it back!',
      },
      {
        time: 505,
        text: "Next, the mighty Thunder Axe kick! Lift your leg super high and straight, then CHOP your heel down like a giant hammer! Let's do ten with the right leg! Up high... and CHOP!",
      },
      {
        time: 535,
        text: 'Now ten with the left leg! Stretch it to the sky and bring the thunder down!',
      },
      {
        time: 565,
        text: "MINI COMBO! Do a right Donkey Kick, then a right Thunder Axe Kick, without putting your foot down! BLAST back... then CHOP down! Let's try that five times!",
      },
      {
        time: 595,
        text: "Now the left side! Five times! Left Donkey Kick into a left Thunder Axe! You've got this!",
      },
      {
        time: 625,
        text: 'You are a master of power! It is time for Spinning and Flying! First, the Tornado Kick! Remember: LOOK over your shoulder, TURN your body, and KICK straight back!',
      },
      {
        time: 645,
        text: "Let's do ten slow and controlled Tornado Kicks with the right leg! Look, turn, KICK! Be careful and powerful!",
      },
      {
        time: 680,
        text: 'Now ten with the left leg! Look over that left shoulder, spin, and BLAST the kick!',
      },
      {
        time: 715,
        text: "Time to fly! Let's do the Sky Kick! This is a flying Side Blaster! Step forward, jump, pull your front knee up, and in the air, BLAST your other foot out sideways!",
      },
      {
        time: 735,
        text: "Let's try ten with the right leg! Step, jump, BLAST! Land softly!",
      },
      {
        time: 765,
        text: "Now ten with the left leg! Get some air! You're flying!",
      },
      {
        time: 795,
        text: "Next up, Defense and Counters! Let's play a game! When I say HIGH, you High Block and counter with a Jab-Cross! When I say LOW, you Low Block and counter with a Slingshot Kick! When I say MIDDLE, you block your tummy and counter with a Side Blaster!",
      },
      {
        time: 825,
        text: 'Ready? HIGH! (Block, Jab-Cross!) LOW! (Block, Slingshot!) MIDDLE! (Block, Side Blaster!) HIGH! (Block, Jab-Cross!)',
      },
      {
        time: 850,
        text: "Let's keep going, faster! LOW! MIDDLE! HIGH! MIDDLE! LOW! HIGH! You are untouchable!",
      },
      {
        time: 875,
        text: 'You have passed every test! This is it... the FINAL GAUNTLET! Three ultimate combos to prove you are a Grandmaster! Catch your breath... here we go!',
      },
      {
        time: 895,
        text: "First, the Tiger's Rage Combo! It's a Jab-Cross, then a Right Slingshot Kick, then a Left Slingshot Kick! We'll do it FIVE times! Go! PUNCH-PUNCH, KICK, KICK!",
      },
      {
        time: 935,
        text: "Amazing! Next, the Dragon's Flight Combo! It's a Right Donkey Kick, a Left Thunder Axe, and a Right Sky Kick! Power, power, and flight!",
      },
      {
        time: 960,
        text: "Let's do the Dragon's Flight FIVE times! Give me your loudest KIAI on the flying kick! Go!",
      },
      {
        time: 1000,
        text: "You are a true warrior! This is the last one! The Grandmaster's Final Test! It's a Right Tornado Kick, a Left Slingshot Kick, and then a Right Jab-Cross-Hook combo!",
      },
      {
        time: 1030,
        text: "This is it! Everything you've got! Five times through! Ready? GO!",
      },
      {
        time: 1070,
        text: 'YOU HAVE COMPLETED THE GAUNTLET! YOU ARE A TRUE TAEKWONDO MASTER! Stand tall in your victory stance! Feet wide, hands high! Feel that power!',
      },
      {
        time: 1085,
        text: "Time for the Champion's Cool Down. Take a giant breath in, and let it all out. Circle your arms forward five times... and backwards five times.",
      },
      {
        time: 1105,
        text: "Let's thank our legs. Gently pull your right foot to your back for a stretch... and now switch to the left foot. You did so many amazing kicks today.",
      },
      {
        time: 1125,
        text: 'Sit on the floor and put the bottoms of your feet together. Gently press your knees down. You have shown power, speed, and focus.',
      },
      {
        time: 1145,
        text: 'Now stretch your legs out wide in front of you and reach for the middle. Hold for a few seconds.',
      },
      {
        time: 1160,
        text: 'Stand up slowly. You mastered every skill: punches, kicks, advanced kicks, flying kicks, spins, and defense. You should be incredibly proud.',
      },
      {
        time: 1175,
        text: "Bring your feet together. It is time for our final sign of respect. Perform a slow, deep, and proud Grandmaster's bow. Incredible work today, champion!",
      },
    ],
    timeTotal: 1185,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // BEGINNER TAEKWONDO STANCES (30 minutes) DONE
  {
    id: 2124,
    name: 'Beginner Taekwondo Stances',
    categories: ['Stances', 'beginner'],
    sports: ['taekwondo'],
    difficulty: 'beginner',
    skill: 'Stances',
    points: 30,
    instructions:
      "Get ready to build your superhero foundation! This adventure is all about learning the powerful stances of Taekwondo. We'll turn stances into a fun game, build awesome balance, and learn the secret power poses of a true champion!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, future champion! Let's get started by jumping into our Fighter Stance! That means feet wide, knees bent, and hands up by your cheeks like a superhero shield!",
      },
      {
        time: 12,
        text: 'Perfect! Now, start a light hero bounce! Heel to toe, heel to toe! Be springy and ready for anything! Keep that shield up!',
      },
      {
        time: 25,
        text: "Let's get our energy up with ten Star Jumps! Go! One, two, three, four, five, six, seven, eight, nine, ten! Awesome!",
      },
      {
        time: 40,
        text: 'Back to bouncing! Now ten Butt Kicks! Try to kick your bottom while you jog in place! Go!',
      },
      {
        time: 55,
        text: "Let's play TIGER FREEZE! I'm going to try to catch you moving! Bouncing, bouncing... TIGER FREEZE! Gotcha! Okay, back to bouncing!",
      },
      {
        time: 75,
        text: "One more time, faster! Bouncing, shuffling, moving around... TIGER FREEZE! Perfect stillness! You are a master! Okay, let's learn our first pose.",
      },
      {
        time: 95,
        text: "Our first official pose is the Ready Stance. It means you are ready for anything! Stand with your feet shoulder-width apart. We're going to make two fists and bring them up like you're roaring, then slowly bring them down in front of your belt. Try it! Roar and down! That's your Ready Stance!",
      },
      {
        time: 120,
        text: "Let's practice that! Start bouncing... and when I say 'READY STANCE', you make your fists and settle into your pose! Ready? GO! READY STANCE! Hold it strong! ... Awesome! Back to bouncing!",
      },
      {
        time: 140,
        text: "Let's do that five times! Get sharp! READY STANCE! ... and bounce. READY STANCE! ... and bounce. Three more! Four! Five! Great focus!",
      },
      {
        time: 165,
        text: "Next up is the Walking Stance! This is our Hero March! From your Ready Stance, just take a big, strong step forward. Bend your front knee a little and keep your back leg straight. It's like you're marching into action!",
      },
      {
        time: 185,
        text: "Let's play Red Light, Green Light! When I say Green Light, you march forward with big, strong Walking Stance steps. When I say Red Light, you freeze! Ready? GREEN LIGHT! March, march, march!",
      },
      {
        time: 205,
        text: 'RED LIGHT! FREEZE! Is your front knee bent? Back leg straight? Awesome! Now, GREEN LIGHT! March backwards to where you started! Go!',
      },
      {
        time: 225,
        text: "RED LIGHT! FREEZE! Perfect! Let's do another round! GREEN LIGHT! March forward, even stronger this time!",
      },
      {
        time: 245,
        text: 'RED LIGHT! Now, from this stance, give me a fast punch with your front hand! PUNCH! Great! GREEN LIGHT, march back!',
      },
      {
        time: 265,
        text: 'RED LIGHT! Freeze! And PUNCH! Awesome! Jump back to your Ready Stance! And bounce!',
      },
      {
        time: 280,
        text: "Time to level up to the Front Stance! This is a super-powered Walking Stance! It's longer and stronger, like a superhero lunging into battle. Take a really big step forward and bend that front knee a lot!",
      },
      {
        time: 300,
        text: "Let's practice! From Ready Stance, take a big lunge forward into a right leg Front Stance! Hold it! Feel the power! Now push back. Now a big lunge with the left leg! And back!",
      },
      {
        time: 325,
        text: "Let's do five on each side! Step, LUNGE! And back. That's one! Keep going! Strong legs!",
      },
      {
        time: 350,
        text: "BALANCE CHALLENGE! Step into a Front Stance with your right leg and hold it for ten seconds! Don't wobble! Ten, nine, eight, seven, six, five, four, three, two, one! Great job! Now the left leg! Hold it strong for ten seconds!",
      },
      {
        time: 380,
        text: "Excellent balance! Now let's add a power punch! Step into your right Front Stance and add a strong cross punch with your back hand! LUNGE and POW! Let's do that five times!",
      },
      {
        time: 405,
        text: 'Now the left side! Step into a left Front Stance and punch with your right hand! Five times! LUNGE and POW!',
      },
      {
        time: 430,
        text: "Next is the sneaky Back Stance! This is your Lookout Pose! Your feet make an 'L' shape. Your front foot points forward, and your back foot points to the side. Bend both knees and put most of your weight on your back leg, like you're peeking around a corner!",
      },
      {
        time: 455,
        text: "Let's try it! From Ready Stance, step your right foot forward and your left foot to the side to make that L-shape! Sit on that back leg! Great! Back to ready. Now the other side! Practice this a few times!",
      },
      {
        time: 480,
        text: "Let's play STANCE SWITCH! I'll call out FRONT or BACK! You have to get into that stance as fast as you can! Use your right leg as the front leg! Ready? FRONT STANCE! ... BACK STANCE! ... BACK STANCE! ... FRONT STANCE! Awesome!",
      },
      {
        time: 505,
        text: "Now with the left leg in front! Faster this time! FRONT STANCE! ... BACK STANCE! ... FRONT STANCE! ... BACK STANCE! You're so fast!",
      },
      {
        time: 525,
        text: "Let's add a block! Get in your right Back Stance and do a High Block! Now left Back Stance, High Block! Let's do that five times each side! Stance and BLOCK!",
      },
      {
        time: 550,
        text: 'Back to bouncing! One more stance! The super strong Horse Stance, or Sumo Stance!',
      },
      {
        time: 565,
        text: "Step your feet out super wide, with your toes pointing forward. Now, bend your knees and sink your body down like you're riding a horse or getting ready for a sumo match! Get low!",
      },
      {
        time: 585,
        text: "HORSE STANCE CHALLENGE! Let's hold our Horse Stance for fifteen seconds! Keep your back straight! Ready? Go! Fifteen, fourteen... keep holding!... ten, nine, eight... you can do it!... five, four, three, two, one! Woo! Stand up and shake it out!",
      },
      {
        time: 615,
        text: "Let's do it again! Get into your Horse Stance, and this time, give me ten fast punches straight out in front of you! Ready? Get low and... PUNCH! One to ten!",
      },
      {
        time: 635,
        text: "Don't stand up yet! Stay in that Horse Stance! Now give me ten High Blocks, switching arms each time! One, two, three, four, five, six, seven, eight, nine, ten! NOW you can stand up! Awesome work!",
      },
      {
        time: 660,
        text: "You have learned all the power poses! It is time for the GRANDMASTER STANCE CHALLENGE! I'm going to call out any stance, and you get into it as fast as you can! This is round one, get ready!",
      },
      {
        time: 680,
        text: 'WALKING STANCE! ... Now! HORSE STANCE! ... Now! BACK STANCE! ... Now! FRONT STANCE! ... And back to READY STANCE!',
      },
      {
        time: 705,
        text: 'Incredible! That was just the warm-up! ROUND TWO! A little faster! Are you ready?! HORSE STANCE! ... FRONT STANCE! ... WALKING STANCE! ... BACK STANCE! ... READY STANCE! You are a stance master!',
      },
      {
        time: 730,
        text: 'WOW! Okay, this is it! The final round! LIGHTNING SPEED! Get ready! GO! FRONT STANCE! BACK STANCE! HORSE STANCE! READY STANCE! WALKING STANCE! BACK STANCE! HORSE STANCE! AMAZING!',
      },
      {
        time: 760,
        text: 'YOU DID IT! You mastered all the power poses! Stand in your Ready Stance, and take a big, deep breath in... and let it all out.',
      },
      {
        time: 775,
        text: "Time for a champion's cool down. Stand with your feet wide and reach down to touch your right foot. Hold it... now reach for your left foot. Hold it...",
      },
      {
        time: 795,
        text: 'Now, stand up and gently pull your right foot to your back for a stretch... and switch to the left foot. You worked your legs hard today!',
      },
      {
        time: 810,
        text: 'Great job today! You learned how to stand like a true Taekwondo champion, and you proved you have amazing balance and focus.',
      },
      {
        time: 825,
        text: "Let's finish with our sign of respect. Stand tall, feet together... and perform a proud bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 835,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // INTERMEDIATE TAEKWONDO FOOTWORK (45 minutes) DONE
  {
    id: 2125,
    name: 'Intermediate Taekwondo Footwork',
    categories: ['Footwork', 'intermediate'],
    sports: ['taekwondo'],
    difficulty: 'intermediate',
    skill: 'Footwork',
    points: 45,
    instructions:
      "Ready to get super-speed feet? This mission is all about learning secret footwork tricks to make you fast, sneaky, and impossible to catch! We'll learn to glide, slide, and switch directions like a phantom! Let's power up our Tiger Feet!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Footwork Master! Let's begin! Jump into your Fighter Stance! Feet wide, knees bent, and your superhero shield is UP by your face!",
      },
      {
        time: 12,
        text: "Start your Tiger Bounce! Be light on your feet, ready to move! Let's get our energy up with ten Star Jumps! Go!",
      },
      {
        time: 30,
        text: 'Great! Back to bouncing! Now, twenty High Knees, get them up to your belly button! Go, go, go!',
      },
      {
        time: 50,
        text: "Awesome! Let's practice our Tiger Feet! We want to be super quiet, like a tiger sneaking through the jungle. Let's bounce without making a sound!",
      },
      {
        time: 65,
        text: "And... TIGER FREEZE! Hold that stance! Are your knees bent? Guard up? Perfect! Okay, let's bounce!",
      },
      {
        time: 80,
        text: "First move: the Tiger Pounce! This is how we move forward! Push off your back foot and take a quick step forward, and your back foot follows. Let's do five slow ones to get it right. Push, step, follow!",
      },
      {
        time: 105,
        text: "Now the Tiger Leap Back! Push off your front foot and take a quick step back. Let's do five slow ones. Push, step back, follow!",
      },
      {
        time: 130,
        text: "Let's play a game! When I say POUNCE, you take one step forward! When I say LEAP, you take one step back! Ready? POUNCE! ... LEAP! ... LEAP! ... POUNCE! ... POUNCE!",
      },
      {
        time: 155,
        text: "SPEED DRILL! Let's do three fast pounces forward, then three fast leaps back! We'll do this for three rounds! ROUND ONE... GO! Forward, two, three! And back, two, three!",
      },
      {
        time: 175,
        text: 'ROUND TWO! A little faster! Go! Pounce, pounce, pounce! Leap, leap, leap!',
      },
      {
        time: 195,
        text: 'FINAL ROUND! Your fastest yet! Go! Forward, forward, forward! Back, back, back! Awesome speed!',
      },
      {
        time: 215,
        text: 'Great job! Keep bouncing! Time to move side-to-side with the Side Glide!',
      },
      {
        time: 230,
        text: "To Side Glide right, take a step with your right foot, and your left foot quickly follows to catch up! Let's do five glides to the right! Go!",
      },
      {
        time: 250,
        text: 'Now five glides to the left! Step with your left foot, and your right foot follows! Keep your superhero shield up!',
      },
      {
        time: 270,
        text: "Let's play the Floor is Lava! You have to glide from one side to the other without touching the lava in the middle! Ready? Glide right, two, three! Now glide left, two, three! Don't get burned!",
      },
      {
        time: 295,
        text: "Let's do that again, even faster! Glide right! Glide left! You're too quick for the lava!",
      },
      {
        time: 315,
        text: 'SIDE GLIDE SPEED DRILL! 20 seconds of gliding right and left as fast as you can! Ready... Set... GO!',
      },
      {
        time: 335,
        text: 'Time! Incredible! Keep bouncing! Now we learn to move on angles with the Zig-Zag Step!',
      },
      {
        time: 350,
        text: "Imagine a big 'V' on the floor. To Zig-Zag forward, step to the top right corner of the V, then bring your other foot up. Then back to the middle, and step to the top left corner! Let's try it! Right corner, middle! Left corner, middle!",
      },
      {
        time: 375,
        text: "Let's do that five times, speeding up each time! One! ... Two! ... Three! ... Four! ... Five! Great angles!",
      },
      {
        time: 400,
        text: "Now let's do a backwards Zig-Zag! Step to the bottom right corner, then back to middle! Then the bottom left corner, and back to middle! This is how you dodge and weave!",
      },
      {
        time: 425,
        text: "Let's do five backwards Zig-Zags! Be quick and light on your feet! Go!",
      },
      {
        time: 450,
        text: "ZIG-ZAG CHALLENGE! Let's make a combo! Do a forward Zig-Zag, then a backward Zig-Zag! We'll do this five times! Go! Forward right, forward left! Now backward right, backward left! That's one!",
      },
      {
        time: 485,
        text: 'Keep bouncing! Time for the sneakiest move of all... the Switcheroo!',
      },
      {
        time: 495,
        text: "The Switcheroo is a magic trick for your feet! You just jump and switch which foot is in front! Try it! SWITCH! And SWITCH back! It's so fast!",
      },
      {
        time: 515,
        text: "Let's do ten fast Switcheroos! Go! One, two, three, four, five, six, seven, eight, nine, ten! Awesome!",
      },
      {
        time: 535,
        text: "Now for the Fake-Out Step! This is a tiny little hop or stutter step you do before you really move, to trick an opponent! Let's practice! Do a little hop, then a big Tiger Pounce forward! Fake-out, then POUNCE!",
      },
      {
        time: 555,
        text: "Let's try it with a leap back! Do a little Fake-Out hop, then a big Tiger Leap Back! Go! Fake-out, then LEAP!",
      },
      {
        time: 575,
        text: "Let's drill that! Fake-out Pounce, five times! Then Fake-out Leap, five times! Go!",
      },
      {
        time: 605,
        text: "You have learned all the secret footwork moves! It is time for the PHANTOM FOOTWORK CHALLENGE! I'm going to call out a combo, and you have to do it! We'll do each combo multiple times! Ready?",
      },
      {
        time: 625,
        text: "First combo: The Ghost Glide! It's a Side Glide right, a Side Glide left, then a Switcheroo! Let's do it FIVE times! Go!",
      },
      {
        time: 660,
        text: "Amazing! Keep bouncing, catch your breath! Next combo: The Tiger's Path! It's a Tiger Pounce forward, a Zig-Zag step right, then a Tiger Leap Back!",
      },
      {
        time: 685,
        text: "Let's do The Tiger's Path five times! Be strong and fast! Go!",
      },
      {
        time: 720,
        text: "Incredible! This is the final combo: The Phantom's Trick! It's a Fake-Out step, then a Switcheroo, then a Tiger Leap Back! So sneaky!",
      },
      {
        time: 745,
        text: "This is it! Let's do The Phantom's Trick five times! Give it all you've got! Go!",
      },
      {
        time: 780,
        text: "Let's put it all together in a final SPEED ROUND! I'll call out a move, you do it! One after another! Ready? TIGER POUNCE! ... SIDE GLIDE LEFT! ... SWITCHEROO! ... TIGER LEAP BACK! ... ZIG-ZAG FORWARD! ... FAKE-OUT STEP!",
      },
      {
        time: 810,
        text: 'FASTER! POUNCE! LEAP! GLIDE! SWITCH! ZIG-ZAG! FAKE-OUT! KEEP GOING! POUNCE! LEAP! GLIDE! SWITCH! ZIG-ZAG! FAKE-OUT!',
      },
      {
        time: 840,
        text: 'YOU DID IT! You are a true Phantom Footwork Master! Stand tall, catch your breath. You earned it!',
      },
      {
        time: 855,
        text: 'Time to cool down. Take a giant breath in, and let it all out. Circle your ankles one way... and then the other. Now switch feet.',
      },
      {
        time: 875,
        text: 'Now gently pull your right knee to your chest and hold... and switch to your left knee. Your feet did so much work today!',
      },
      {
        time: 890,
        text: 'Great job today! You learned how to move like a champion, with speed, grace, and sneaky tricks!',
      },
      {
        time: 900,
        text: "Let's finish with our sign of respect. Stand tall, feet together... and perform a proud bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 910,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // ADVANCED TAEKWONDO COMBINATIONS (45 minutes)
  {
    id: 2126,
    name: 'Advanced Taekwondo Combinations',
    categories: ['Combinations', 'advanced'],
    sports: ['taekwondo'],
    difficulty: 'advanced',
    skill: 'Combinations',
    points: 45,
    instructions:
      "Get ready to become a Combo King or Queen! This mission is all about linking your amazing kicks together into secret black belt sequences. We'll build speed, power, and flow to make you an unstoppable Taekwondo hero! Let's begin!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Combo Master! Let's get into your strong Fighter Stance! Feet wide, knees bent, and that superhero shield is up and ready!",
      },
      {
        time: 12,
        text: "Start your champion bounce! Be light on your feet! Let's get the energy flowing with twenty Star Jumps! Go!",
      },
      {
        time: 35,
        text: "Great! Back to bouncing! Let's warm up our hips with big leg swings! Hold a wall if you need to. Swing your right leg forward and back ten times, then side to side ten times!",
      },
      {
        time: 60,
        text: 'Now the left leg! Swing it forward and back ten times, then side to side ten times! Get those legs ready for some awesome combos!',
      },
      {
        time: 85,
        text: "And... TIGER FREEZE! Hold that stance! Perfect focus! Okay, let's get bouncing!",
      },
      {
        time: 95,
        text: "Before we build combos, let's warm up our weapons! We're going to do a rapid-fire drill! Ten of each kick! Ready? Ten right leg Lightning Kicks! Go!",
      },
      {
        time: 115,
        text: 'Now ten left leg Lightning Kicks! Fast snaps!',
      },
      {
        time: 135,
        text: 'Ten right leg Side Blasters! Push with that heel!',
      },
      {
        time: 155,
        text: 'Ten left leg Side Blasters! Keep that guard up!',
      },
      {
        time: 175,
        text: 'Ten right leg Slingshot Kicks! Turn and WHIP!',
      },
      {
        time: 195,
        text: 'Ten left leg Slingshot Kicks! Make a swoosh sound!',
      },
      {
        time: 215,
        text: "And ten right Donkey Kicks! Peek and BLAST! ... And finally, ten left Donkey Kicks! You're ready to build!",
      },
      {
        time: 245,
        text: "Our first secret sequence is called... The Tiger's Claw! It's a Right Lightning Kick, and then WITHOUT putting your foot down, you turn it into a Right Slingshot Kick! It's a one-two kick! A SNAP-WHIP!",
      },
      {
        time: 270,
        text: "Let's practice it slowly. Right leg. Knee up, SNAP forward, pull it back, turn your body, and WHIP it sideways! Let's do that five times slowly to get the balance.",
      },
      {
        time: 300,
        text: 'Now the left leg! A left SNAP-WHIP! Five times, nice and slow. Lightning Kick into a Slingshot Kick!',
      },
      {
        time: 330,
        text: "You've got it! POWER ROUND! Let's do five fast Tiger's Claw combos on the right leg! Go! SNAP-WHIP! That's one! Four more!",
      },
      {
        time: 355,
        text: 'Now five fast ones on the left! Make a loud KIAI on the second kick! Go! SNAP-WHIP!',
      },
      {
        time: 380,
        text: "TIGER'S CLAW SPEED DRILL! For 30 seconds, do as many SNAP-WHIP combos as you can, switching legs each time! Ready... GO!",
      },
      {
        time: 410,
        text: 'Time! Incredible! Shake your legs out and get ready for the next combo!',
      },
      {
        time: 420,
        text: "The next combo is The Dragon's Tooth! This one uses both legs! You start with a Right Slide-In Side Blaster, then as you land, you do a powerful Left Donkey Kick! It's an attack and an escape!",
      },
      {
        time: 445,
        text: "Let's break it down. You slide in and BLAST with your right heel! Then you land, peek over your left shoulder, and BLAST with your left heel! Let's try that slowly five times.",
      },
      {
        time: 480,
        text: "Now let's switch it! A Left Slide-In Side Blaster, followed by a Right Donkey Kick! Let's do that slowly five times to get the feel for it.",
      },
      {
        time: 515,
        text: "POWER ROUND! Let's do five fast Dragon's Tooth combos, starting with the right kick! Go! SLIDE-BLAST, PEEK-KICK!",
      },
      {
        time: 545,
        text: 'Now five fast ones starting with the left kick! Go! SLIDE-BLAST, PEEK-KICK! Awesome power!',
      },
      {
        time: 575,
        text: 'Amazing work! Keep bouncing! This is the black belt combo... The Phoenix Fury! It uses a spinning kick!',
      },
      {
        time: 590,
        text: "The Phoenix Fury is a Right Cyclone Kick, and as you land, you immediately launch a Left Slingshot Kick! It's a SPIN-WHIP, then a regular WHIP!",
      },
      {
        time: 610,
        text: "First, let's practice just the Cyclone Kick. Remember? Step across, knee up, look, and spin! Let's do five right Cyclone Kicks to warm up the spin!",
      },
      {
        time: 635,
        text: "Now let's try the full combo slowly. Right Cyclone Kick, land quietly, and immediately throw a Left Slingshot Kick! Let's do it five times slowly.",
      },
      {
        time: 670,
        text: "Now let's switch sides! A Left Cyclone Kick, into a Right Slingshot Kick! Five times, nice and controlled!",
      },
      {
        time: 705,
        text: "POWER ROUND! Let's do five fast Phoenix Fury combos, starting with the right spin! Go! SPIN-WHIP, WHIP!",
      },
      {
        time: 735,
        text: "Now five fast ones starting with the left spin! You're a spinning blur! Go!",
      },
      {
        time: 765,
        text: "You have learned all the secret sequences! It's time for The Grandmaster's Gauntlet! I'm going to call out a combo name, and you have to do it as fast as you can! Ready?",
      },
      {
        time: 785,
        text: "TIGER'S CLAW! right side! ... Now! DRAGON'S TOOTH! left side! ... Now! PHOENIX FURY! right side! ... Great job!",
      },
      {
        time: 810,
        text: "ROUND TWO! FASTER! PHOENIX FURY! left side! ... TIGER'S CLAW! left side! ... DRAGON'S TOOTH! right side! Incredible speed!",
      },
      {
        time: 835,
        text: "FINAL ROUND! LIGHTNING SPEED! TIGER'S CLAW! DRAGON'S TOOTH! PHOENIX FURY! TIGER'S CLAW! DRAGON'S TOOTH! PHOENIX FURY! YOU DID IT!",
      },
      {
        time: 865,
        text: 'YOU ARE A TRUE COMBO MASTER! Stand tall and catch your breath! That was amazing!',
      },
      {
        time: 880,
        text: "Time for a champion's cool down. Take a giant breath in, reach for the sky... and let it all out.",
      },
      {
        time: 895,
        text: 'Sit on the floor with your legs in a V-shape. Gently reach for your right foot and hold for ten seconds... now reach for your left foot and hold for ten seconds.',
      },
      {
        time: 920,
        text: 'Now reach for the middle and hold for ten seconds. You worked your whole body today!',
      },
      {
        time: 935,
        text: 'You should be so proud! You mastered three secret black belt combos and proved you have amazing skill and power.',
      },
      {
        time: 945,
        text: "Let's finish with our sign of respect. Stand tall, feet together... and perform a proud, Grandmaster's bow. Fantastic work today, champion!",
      },
    ],
    timeTotal: 955,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // BEGINNER TAEKWONDO DEFENSE (30 minutes)
  {
    id: 2127,
    name: 'Beginner Taekwondo Defense',
    categories: ['Defense', 'beginner'],
    sports: ['taekwondo'],
    difficulty: 'beginner',
    skill: 'Defense',
    points: 30,
    instructions:
      "Ready to become an unstoppable defender? This mission is all about building your own personal force field! You'll learn awesome blocks to protect yourself, sneaky dodges to escape trouble, and super-fast counter-attacks to surprise everyone! Let's power up your defense!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Defender! Let's get started by jumping into our Fighter Stance! That means feet wide, knees bent, and hands up by your cheeks like a superhero shield! This is your first line of defense!",
      },
      {
        time: 15,
        text: 'Perfect! Now, start a light hero bounce! Heel to toe, heel to toe! A moving target is hard to hit! Keep that shield up!',
      },
      {
        time: 30,
        text: "Let's get our energy up with twenty Star Jumps! Go! One, two, three... keep going!... eighteen, nineteen, twenty! Awesome!",
      },
      {
        time: 55,
        text: 'Back to bouncing! Now twenty High Knees! Get them up to your belly button! Quick feet! Go, go, go!',
      },
      {
        time: 75,
        text: "Great warm-up! Let's play a quick game of TIGER FREEZE! When I say freeze, you hold your best fighter stance! Ready? Bouncing, bouncing... TIGER FREEZE! Don't move a muscle! ... Great! Back to bouncing!",
      },
      {
        time: 100,
        text: "First, we build your force field with BLOCKS! The first is the High Block! To do it, swing your arm up above your head, like you're blocking a giant water balloon! Let's do ten with your right arm! Go!",
      },
      {
        time: 125,
        text: 'Now ten with your left arm! Swing it up there, strong arm! One, two, three, four, five, six, seven, eight, nine, ten!',
      },
      {
        time: 150,
        text: "Next is the Low Block! This is for protecting your legs. Swing your arm down and across your body, like you're sweeping away pesky lava! Let's do ten with your right arm!",
      },
      {
        time: 175,
        text: 'Now ten with your left arm! Swing it down and across! WHOOSH! Keep that other hand up in your guard!',
      },
      {
        time: 200,
        text: "Last one is the Middle Block! This protects your tummy! Make a strong arm and sweep it across your body, like you're closing a castle door! Let's do ten with your right arm!",
      },
      {
        time: 225,
        text: 'Now ten with the left arm! Close that castle door! STRONG!',
      },
      {
        time: 250,
        text: "Let's play the BLOCK PARTY game! I'm going to call out HIGH, LOW, or MIDDLE! You do the block as fast as you can with either arm! Ready? HIGH! ... LOW! ... MIDDLE! ... HIGH! ... MIDDLE! ... LOW! ... Faster! HIGH! LOW! MIDDLE!",
      },
      {
        time: 285,
        text: "You're a blocking machine! Keep bouncing! Now let's learn some sneaky dodges!",
      },
      {
        time: 300,
        text: "First is the Slip! Imagine a slow-motion water balloon coming at your nose. Just move your head a little to the right, then a little to the left! Just your head moves! Let's practice! Slip right, slip left, slip right, slip left!",
      },
      {
        time: 325,
        text: "Next is the Bob and Weave! Imagine a laser beam at your shoulder height. You have to duck under it! Bend your knees to go down and make a 'U' shape with your head to come up the other side! Let's practice! Duck and weave! And back the other way!",
      },
      {
        time: 355,
        text: "Last dodge is the Leap Back! This is your emergency escape button! Just push hard off your front foot and leap backwards! Let's try it! And... LEAP BACK! And get right back to your stance!",
      },
      {
        time: 375,
        text: "Let's play the DODGEBALL game! I'll call out what's coming at you! If I say 'WATER BALLOON', you slip! If I say 'LASER BEAM', you bob and weave! If I say 'GIANT BOULDER', you leap back! Ready?",
      },
      {
        time: 400,
        text: "GIANT BOULDER! (Leap Back!) ... WATER BALLOON! (Slip!) ... LASER BEAM! (Bob and Weave!) ... WATER BALLOON! (Slip!) ... GIANT BOULDER! (Leap Back!) You're untouchable!",
      },
      {
        time: 430,
        text: "Amazing dodging! Now, the best defense is a good offense! It's time to learn how to BLOCK and COUNTER-ATTACK!",
      },
      {
        time: 445,
        text: "Combo number one! Do a right High Block, then immediately counter with a fast Jab-Cross! It's a BLOCK, then PUNCH-PUNCH! Let's do that five times!",
      },
      {
        time: 470,
        text: 'Now the left side! Left High Block, then a Jab-Cross! Five times! Block and strike!',
      },
      {
        time: 495,
        text: "Combo number two! Do a right Low Block, then counter with a left Lightning Kick! So you block low, and kick high! Let's try it five times! BLOCK... then SNAP!",
      },
      {
        time: 520,
        text: 'Now the other side! Left Low Block, then a right Lightning Kick! Five times! Great work!',
      },
      {
        time: 545,
        text: "Final counter combo! Do a right Middle Block, then counter with a left Side Blaster kick! Block the tummy, then push them away! Let's do it five times!",
      },
      {
        time: 570,
        text: "Now the other side! Left Middle Block, then a right Side Blaster! Five times! You've got this!",
      },
      {
        time: 595,
        text: "You have learned all the defender's secrets! It's time for the ULTIMATE DEFENDER CHALLENGE! I'm going to call out an attack, and you do the right defense and counter! Ready?",
      },
      {
        time: 615,
        text: 'Incoming HIGH PUNCH! (Right high block, jab-cross!) ... Incoming LOW KICK! (Left low block, right lightning kick!) ... Incoming TUMMY PUNCH! (Right middle block, left side blaster!)',
      },
      {
        time: 640,
        text: 'Get ready, faster now! Incoming LOW KICK! (Right low block, left lightning kick!) ... Incoming HIGH PUNCH! (Left high block, jab-cross!) ... Incoming TUMMY PUNCH! (Left middle block, right side blaster!)',
      },
      {
        time: 665,
        text: 'Now for the dodge round! DODGE THE WATER BALLOON! (Slip!) ... DODGE THE LASER BEAM! (Bob and weave!) ... GET AWAY FROM THE BOULDER! (Leap back!)',
      },
      {
        time: 685,
        text: 'Final round, anything goes! HIGH PUNCH! ... LOW KICK! ... GET AWAY! ... TUMMY PUNCH! ... DODGE THE WATER BALLOON! YOU ARE UNBEATABLE!',
      },
      {
        time: 710,
        text: 'YOU DID IT! Your force field is at full power! Stand tall and catch your breath. That was amazing work!',
      },
      {
        time: 725,
        text: "Time for a champion's cool down. Take a giant breath in, and let it all out. Roll your shoulders backwards five times... and forwards five times.",
      },
      {
        time: 745,
        text: 'Now, gently pull your right arm across your chest for a stretch... and switch to the left arm.',
      },
      {
        time: 765,
        text: 'Great job today! You learned how to protect yourself with blocks and move with sneaky dodges. You are a true Taekwondo defender.',
      },
      {
        time: 780,
        text: "Let's finish with our sign of respect. Stand tall, feet together... and perform a proud, defender's bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 790,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // INTERMEDIATE TAEKWONDO SPARRING (45 minutes)
  {
    id: 2128,
    name: 'Intermediate Taekwondo Sparring',
    categories: ['Sparring', 'intermediate'],
    sports: ['taekwondo'],
    difficulty: 'intermediate',
    skill: 'Sparring',
    points: 45,
    instructions:
      "Get ready to play the ultimate game of Sparring Tag! This mission is all about using your awesome Taekwondo moves to be super fast and super smart. You'll learn how to move, dodge, block, and score points against an imaginary partner. Let's become a Sparring Champion!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Sparring Champion! Let's get ready for our game! Jump into your Sparring Stance! That means feet are wide, knees are bent, and you're bouncing lightly on your toes!",
      },
      {
        time: 15,
        text: 'Most important rule: this is a fun, NO-CONTACT game! We are shadow sparring, which means we are fighting an imaginary partner. Keep your hands and feet to yourself. Now, get that superhero shield up by your face!',
      },
      {
        time: 35,
        text: "Let's warm up! Twenty Star Jumps! Go! Get that heart pumping!",
      },
      {
        time: 60,
        text: 'Great! Back to your sparring bounce! Now twenty High Knees! Quick feet! Go, go, go!',
      },
      {
        time: 85,
        text: "Awesome! Let's get started with FOOTWORK SCHOOL! To be a champion, you have to move like a phantom! First, the Pounce Forward! Push off your back foot and take a quick step in!",
      },
      {
        time: 105,
        text: "Now the Leap Back! Push off your front foot and leap backwards to safety! Let's play Red Light, Green Light! GREEN LIGHT! Pounce forward and leap back! Be quick!",
      },
      {
        time: 125,
        text: "RED LIGHT! TIGER FREEZE! Perfect stance! GREEN LIGHT! Let's go! Pounce and leap!",
      },
      {
        time: 145,
        text: "RED LIGHT! FREEZE! Great! Now the Side Glide! Step to the right, and your other foot follows! Step to the left, and your other foot follows! Let's do ten glides to the right!",
      },
      {
        time: 170,
        text: 'Now ten glides to the left! Stay low, keep your shield up!',
      },
      {
        time: 195,
        text: "FOOTWORK DRILL! I'm going to call it out! POUNCE FORWARD! ... LEAP BACK! ... GLIDE RIGHT! ... GLIDE LEFT! ... POUNCE! ... GLIDE LEFT! ... LEAP BACK! You're so fast!",
      },
      {
        time: 225,
        text: "Amazing feet! Keep bouncing! Now let's learn our TAGGING TOOLS! This is how you score points in our game!",
      },
      {
        time: 240,
        text: "Your first tool is the Fast Tag! It's a quick Jab-Cross punch! It's your fastest move! Let's practice! Pounce forward and do a Fast Tag! Pounce and PUNCH-PUNCH! Let's do that ten times!",
      },
      {
        time: 275,
        text: "Next is the Long Tag! This is your Side Blaster kick! It keeps your imaginary partner far away! Let's practice by sliding in first. Slide in and do a Long Tag! Let's do that ten times with your right leg!",
      },
      {
        time: 310,
        text: 'Now ten with your left leg! Slide in and BLAST that heel out! Great distance!',
      },
      {
        time: 345,
        text: "Last one is the Surprise Tag! This is your Slingshot Kick! It comes from the side when they don't expect it! Let's use our Switcheroo footwork. Switch your feet and do a Surprise Tag! Let's do ten with your right leg!",
      },
      {
        time: 380,
        text: 'Now ten with your left leg! Switch and WHIP! What a great surprise!',
      },
      {
        time: 415,
        text: "Incredible tags! But a champion needs defense! It's time to build your FORCE FIELD!",
      },
      {
        time: 430,
        text: "Let's review our blocks super fast! High Block stops attacks to the head! Middle Block stops tummy attacks! Low Block stops leg attacks! Let's play BLOCK PARTY! I call it, you block it! Ready?",
      },
      {
        time: 455,
        text: 'HIGH ATTACK! (High Block!) ... TUMMY PUNCH! (Middle Block!) ... LOW KICK! (Low Block!) ... HIGH ATTACK! (High Block!) ... LOW KICK! (Low Block!) Perfect!',
      },
      {
        time: 480,
        text: "Now for dodging! To dodge a straight punch, do the Matrix Move! Just lean your upper body back really fast, then come right back! Let's try it! Lean back! And again!",
      },
      {
        time: 505,
        text: "To dodge a swinging arm, do the Bob and Weave! Duck under it by bending your knees in a 'U' shape! Let's try it! Weave under! And back!",
      },
      {
        time: 530,
        text: "DODGEBALL GAME! If I shout 'STRAIGHT SHOT!', you do the Matrix Move! If I shout 'SWINGING ARM!', you do the Bob and Weave! Ready? STRAIGHT SHOT! ... SWINGING ARM! ... STRAIGHT SHOT! ... SWINGING ARM! You're untouchable!",
      },
      {
        time: 560,
        text: 'Awesome dodging! Now for the best part... COUNTER-ATTACKS! This is when you defend and attack at the same time!',
      },
      {
        time: 575,
        text: "Counter number one! Do a High Block, and then immediately fire back with a Fast Tag! It's a BLOCK then PUNCH-PUNCH! Let's do that ten times!",
      },
      {
        time: 605,
        text: "Counter number two! Do a Low Block, then immediately fire back with a Long Tag side kick! It's a BLOCK then KICK! Let's do that ten times!",
      },
      {
        time: 635,
        text: "Counter number three! Do the Matrix Move, then fire back with a Surprise Tag slingshot kick! It's a DODGE then KICK! Let's do that ten times!",
      },
      {
        time: 665,
        text: 'You have all the skills of a champion! It is time for our CHAMPION SPARRING ROUNDS! Three rounds, full energy! Get ready for round one!',
      },
      {
        time: 685,
        text: 'ROUND ONE! OFFENSE ONLY! For one minute, you can only attack! Use your footwork and your three tags to score as many points as you can on your imaginary partner! Ready... Set... GO!',
      },
      {
        time: 745,
        text: 'TIME! Great round! Catch your breath for ten seconds! Get ready for round two!',
      },
      {
        time: 755,
        text: "ROUND TWO! DEFENSE ONLY! For one minute, you can only block and dodge! Be untouchable! Don't let your imaginary partner score any points! Ready... Set... GO!",
      },
      {
        time: 815,
        text: 'TIME! You are a wall! Incredible defense! Catch your breath for ten seconds! This is the final round!',
      },
      {
        time: 825,
        text: 'ROUND THREE! FULL SPARRING MATCH! This is it! For one minute, use EVERYTHING! Footwork, tags, blocks, dodges, and counters! Be a champion! Ready... Set... GO!',
      },
      {
        time: 885,
        text: 'TIME! YOU DID IT! YOU ARE THE SPARRING CHAMPION! Stand tall and take a deep breath! That was amazing!',
      },
      {
        time: 900,
        text: "Time for our Champion's Cool Down. Take a giant breath in, reach for the sky... and let it all out.",
      },
      {
        time: 915,
        text: "Let's stretch our legs. Gently pull your right knee to your chest and hold... and now switch to the left knee.",
      },
      {
        time: 935,
        text: 'You should be so proud! You learned how to move, attack, and defend like a true Taekwondo champion.',
      },
      {
        time: 945,
        text: "Let's finish with our sign of respect. First, turn and bow to your imaginary partner. Thank them for the great match! Now, face forward, feet together... and perform a proud, champion's bow.",
      },
    ],
    timeTotal: 955,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // ADVANCED TAEKWONDO FORMS (45 minutes)
  {
    id: 2129,
    name: 'Advanced Taekwondo Forms',
    categories: ['Forms', 'advanced'],
    sports: ['taekwondo'],
    difficulty: 'advanced',
    skill: 'Forms',
    points: 45,
    instructions:
      "Get ready to learn a secret warrior pattern, the Dragon Form! A form is like telling an epic story with your Taekwondo moves. This mission is all about focus, power, and perfect technique. Let's awaken the dragon within and master this awesome pattern!",
    timedInstructions: [
      {
        time: 0,
        text: 'Welcome, warrior! Today we learn a secret pattern. But first, we must prepare! Jump into your Fighter Stance! Feet wide, knees bent, shield is UP!',
      },
      {
        time: 15,
        text: "Forms are about strong stances. Let's warm up! Step into a deep Horse Stance and hold it for ten seconds! Get low!",
      },
      {
        time: 30,
        text: 'Great! Now, from your Horse Stance, give me ten powerful middle punches! Go! One, two, three, four, five, six, seven, eight, nine, ten!',
      },
      {
        time: 48,
        text: 'Awesome! Back to bouncing! Now step into a deep right-leg-forward Front Stance! Hold it for ten seconds! Feel that power!',
      },
      {
        time: 63,
        text: 'Now a deep left-leg-forward Front Stance! Hold for ten seconds!',
      },
      {
        time: 78,
        text: 'Now a right-leg-forward Back Stance! Remember the L-shape! Hold it! ... And a left-leg-forward Back Stance! Hold it! Perfect!',
      },
      {
        time: 98,
        text: "Back to bouncing! Let's do a quick block review! Ten High Blocks! Ten Low Blocks! Ten Middle Blocks! Go, go, go!",
      },
      {
        time: 128,
        text: 'Excellent! You are ready. Our secret pattern is called the Dragon Form. A form is a story told with your body. I will teach you the story, piece by piece.',
      },
      {
        time: 145,
        text: 'We always start in the Ready Stance. Remember? Feet shoulder-width, fists come up and then settle by your belt. Get in your Ready Stance now.',
      },
      {
        time: 160,
        text: "Here is Part One of our story, The Dragon Awakens. Move one: Turn to your left and land in a deep Front Stance with a powerful Low Block! Move two: Step forward into another Front Stance with a strong middle punch! That's the first part!",
      },
      {
        time: 185,
        text: "Let's practice that! Back to Ready Stance. And... Turn left, LOW BLOCK! Step forward, PUNCH! Let's do that again! Back to Ready.",
      },
      {
        time: 205,
        text: "Let's drill Part One five times to make it strong! Ready? One! (Turn block, step punch). Reset! Two! ... Three! ... Four! ... Five! Make it sharp!",
      },
      {
        time: 245,
        text: "Great start! Let's learn Part Two, The Dragon's Fury. You just finished your punch. Move three: Turn all the way around to your right, landing in a deep Front Stance with a Low Block. Move four: Step forward into another Front Stance with a middle punch!",
      },
      {
        time: 275,
        text: "Let's practice just that part. From your last punch, turn all the way around to the right, LOW BLOCK! Step forward, PUNCH! Let's do that five times! Reset each time. Go!",
      },
      {
        time: 315,
        text: "Now, let's connect the whole story so far. We will do Part One and Part Two together! That's four moves. Ready Stance to begin.",
      },
      {
        time: 335,
        text: "Let's do it slowly. Turn left, LOW BLOCK! Step forward, PUNCH! Now turn all the way right, LOW BLOCK! Step forward, PUNCH! Awesome! Let's do that whole sequence four more times!",
      },
      {
        time: 395,
        text: "Keep bouncing and shake it out for a moment. You've learned the head and the body of the dragon. Now it's time for the tail!",
      },
      {
        time: 410,
        text: "This is Part Three, The Dragon's Tail Lash! You just finished your last punch. Move five: Turn to your left, into a strong Back Stance with a Middle Block! Move six: Step forward into a Front Stance and do a powerful Slingshot Kick, landing with a High Block! Move seven: A final Donkey Kick straight back with a LOUD KIAI!",
      },
      {
        time: 445,
        text: "Wow! That's the big finish! Let's practice just the tail part five times! Ready? Turn, MIDDLE BLOCK! Step forward, KICK and HIGH BLOCK! DONKEY KICK, KIAI! Reset and go again!",
      },
      {
        time: 505,
        text: 'You have learned all the pieces of the story! You have learned the Dragon Form! Now, we must perform it. First, we will do it twice in slow motion to remember every move.',
      },
      {
        time: 525,
        text: 'Get to your Ready Stance. We will tell the whole story. Slow motion... BEGIN! Turn left, low block... step forward, punch... turn right, low block... step forward, punch... turn left, back stance, middle block... step forward, slingshot kick, land, high block... donkey kick... KIAI! And back to ready.',
      },
      {
        time: 575,
        text: "Beautiful! Let's do that one more time, slow and perfect. Focus on your stances. Are they deep and strong? Are your blocks and punches sharp? Ready... BEGIN!",
      },
      {
        time: 625,
        text: 'Now... you are ready. It is time to perform the Dragon Form with full power! We will do it FIVE times! After each one, you will return to the Ready Stance. Make every move count! Ready?',
      },
      {
        time: 650,
        text: 'DRAGON FORM, ONE! BEGIN! (block, punch, block, punch, block, kick-block, kick-KIAI!) ... Return to Ready!',
      },
      {
        time: 680,
        text: 'Excellent! Catch your breath. DRAGON FORM, TWO! BEGIN! Make it even stronger!',
      },
      {
        time: 710,
        text: 'Return to Ready! Great power! DRAGON FORM, THREE! BEGIN! Sharp moves!',
      },
      {
        time: 740,
        text: 'Return to Ready! Two more left! DRAGON FORM, FOUR! BEGIN! Show me your focus!',
      },
      {
        time: 770,
        text: 'Return to Ready! This is the last one! Make it your best one! The loudest KIAI! DRAGON FORM, FIVE! BEGIN!',
      },
      {
        time: 800,
        text: "Return to Ready! YOU DID IT! You have mastered the Dragon Form! Stand tall and take a deep breath. Feel the dragon's energy!",
      },
      {
        time: 820,
        text: "Time for a Grandmaster's cool down. From your Ready Stance, step into a deep Horse Stance. Place your hands on your knees and gently press your right shoulder down, looking over your left. Hold it.",
      },
      {
        time: 845,
        text: 'Now press your left shoulder down, looking over your right. Hold it.',
      },
      {
        time: 865,
        text: 'Stand up and put your right heel out in front, toes up. Gently lean forward to stretch your leg. Hold for ten seconds... and switch legs.',
      },
      {
        time: 895,
        text: "You should be so proud. You didn't just do kicks and punches, you told a story with your body. That is the true spirit of Taekwondo.",
      },
      {
        time: 910,
        text: "Let's finish with our sign of respect. Stand tall, feet together... and perform a deep, proud, Grandmaster's bow. Incredible focus today, warrior!",
      },
    ],
    timeTotal: 920,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },

  // COMPLETE TAEKWONDO CHAMPIONSHIP (60 minutes)
  {
    id: 2130,
    name: 'Complete Taekwondo Championship',
    categories: ['Championship', 'advanced'],
    sports: ['taekwondo'],
    difficulty: 'advanced',
    skill: 'Championship',
    points: 60,
    instructions:
      "Welcome to the World Taekwondo Championship! Today, YOU are the champion. This is the final test of all your skills. You'll face imaginary opponents in epic rounds of speed, power, and technique. Get ready to win the gold medal!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome to the Championship! Let's get you warmed up for your first match! Jump into your Sparring Stance! Feet wide, knees bent, and that champion's guard is UP!",
      },
      {
        time: 15,
        text: "Start your champion bounce! Light on your feet, focused, and ready! We're shadow sparring today against imaginary opponents, so remember: NO CONTACT! Let's start with twenty Star Jumps! Go!",
      },
      {
        time: 40,
        text: 'Great! Now twenty High Knees to get those legs ready for kicking! Go, go, go!',
      },
      {
        time: 65,
        text: "Now, let's practice our footwork. Give me five Tiger Pounces forward, and five Tiger Leaps back! In and out! Quick!",
      },
      {
        time: 90,
        text: 'Now five Side Glides to the right, and five to the left! Stay low and fast!',
      },
      {
        time: 115,
        text: 'And... TIGER FREEZE! Hold that championship stance! Perfect! Back to bouncing!',
      },
      {
        time: 130,
        text: 'Okay, the tournament is about to begin! Your first match is THE SPEED MATCH! Your opponent is a blur, so you have to be faster! We will use our fastest tools!',
      },
      {
        time: 150,
        text: "First, the Fast Tag! That's your Jab-Cross! Let's do a speed drill! 30 seconds of non-stop Fast Tags! How many can you do? Ready... GO!",
      },
      {
        time: 180,
        text: "Time! Incredible speed! Keep bouncing! Next, your Lightning Kick! It's all about the SNAP! Let's do another 30 second speed drill, switching legs each time! GO!",
      },
      {
        time: 210,
        text: "Time! You're faster than lightning! Now let's combine them! The combo is: Right Fast Tag, into a Right Lightning Kick! Let's do that ten times!",
      },
      {
        time: 245,
        text: 'Now the left side! Left Fast Tag, into a Left Lightning Kick! Ten times! Be a blur!',
      },
      {
        time: 280,
        text: 'You won the first match with pure speed! Great job! Catch your breath! Your next match is THE POWER MATCH! Your opponent is strong, so you need to show your power!',
      },
      {
        time: 300,
        text: 'First, your Long Tag! The Side Blaster kick! We need ten powerful kicks on the right leg! Push your imaginary opponent back! Go! BLAST!',
      },
      {
        time: 330,
        text: 'Now ten powerful Side Blasters with the left leg! Show me that power!',
      },
      {
        time: 360,
        text: 'Next, the Donkey Kick! Peek over your shoulder and drive your heel straight back! Ten powerful kicks with the right leg! Go!',
      },
      {
        time: 390,
        text: 'Now ten with the left leg! Make a loud KIAI on every kick!',
      },
      {
        time: 420,
        text: "Let's combine them for a power combo! Do a Right Side Blaster, then use your footwork to turn and do a Left Donkey Kick! Let's practice that ten times!",
      },
      {
        time: 460,
        text: 'You won with power! Amazing! Keep bouncing! The next round is THE TRICKY MATCH! Your opponent is sneaky, so you need to be trickier!',
      },
      {
        time: 480,
        text: "Let's use our Question Mark Kick! Remember? Kick out past the target, then HOOK your heel back! Let's do ten with the right leg to practice this sneaky move!",
      },
      {
        time: 510,
        text: 'Now ten with the left leg! Out and HOOK! Perfect!',
      },
      {
        time: 540,
        text: "Now for our fastest trick, the Switcheroo Slingshot Kick! Switch your feet and WHIP the kick instantly! Let's do ten with the right leg!",
      },
      {
        time: 570,
        text: "Now ten with the left leg! Be so fast they can't even see it!",
      },
      {
        time: 600,
        text: "Here's the tricky combo! Do a Right Switcheroo Slingshot, and then without putting your foot down, turn it into a Question Mark Kick! It's a WHIP-HOOK! Let's do that five times!",
      },
      {
        time: 630,
        text: 'Now five on the left side! This is a master-level combo! Go!',
      },
      {
        time: 660,
        text: "You outsmarted your opponent! You're in the Semi-Finals! This is THE FLYING MATCH! Your opponent is an acrobat, so you have to take to the air!",
      },
      {
        time: 680,
        text: "Let's practice your Tornado Kick! Look, spin, and KICK! Let's do ten powerful spins with the right leg!",
      },
      {
        time: 715,
        text: "Now ten Tornado Kicks with the left leg! You're a spinning storm!",
      },
      {
        time: 750,
        text: "Now the Sky Kick! The flying Side Blaster! Step, jump, and BLAST your heel out! Let's do ten with the right leg!",
      },
      {
        time: 785,
        text: "Now ten with the left leg! Get some air! You're flying!",
      },
      {
        time: 820,
        text: "Here's the flying combo! Do a Right Tornado Kick, land, and then immediately launch into a Left Sky Kick! A spin then a flight! Let's do that five times!",
      },
      {
        time: 860,
        text: 'You won the flying match! You are in the Gold Medal round! This is it! Three one-minute rounds to become the champion! Catch your breath!',
      },
      {
        time: 880,
        text: 'THE GOLD MEDAL MATCH, ROUND ONE! For one minute, use only your punches and your three basic kicks: Lightning, Side Blaster, and Slingshot! Use your footwork! Ready... GO!',
      },
      {
        time: 940,
        text: 'END OF ROUND ONE! Great work! Ten seconds rest... keep bouncing!',
      },
      {
        time: 950,
        text: 'ROUND TWO! For one minute, you can only use your ADVANCED kicks! Donkey Kicks, Thunder Axe Kicks, and Question Mark Kicks! Be powerful and tricky! Ready... GO!',
      },
      {
        time: 1010,
        text: 'END OF ROUND TWO! Amazing! Ten seconds rest! This is the final round!',
      },
      {
        time: 1020,
        text: 'FINAL ROUND! ANYTHING GOES! Use everything! Your spins, your flying kicks, your best combos! Leave it all in the ring and win the championship! Ready... GO!',
      },
      {
        time: 1080,
        text: 'TIME! YOU DID IT! YOU ARE THE WORLD TAEKWONDO CHAMPION! Stand tall and take a deep breath! That was incredible!',
      },
      {
        time: 1095,
        text: 'It is time for the Award Ceremony. Step up to the top of the podium. Take a deep breath as they place the gold medal around your neck! You earned it!',
      },
      {
        time: 1115,
        text: "Let's do our champion's cool down. Gently pull your right knee to your chest and hold... now switch to the left knee.",
      },
      {
        time: 1135,
        text: 'Now stretch your legs out wide and reach for the middle. You are strong, fast, and smart. A true champion.',
      },
      {
        time: 1155,
        text: "Stand up tall. You are the champion of the world! Let's finish with our sign of respect. Feet together... and perform a deep, proud, champion's bow.",
      },
    ],
    timeTotal: 1165,
    equipment: 'None',
    requiresPartner: false,
    minPlayers: 1,
  },
];

export default taekwondoDrills;
